<template>
    <div class="subscription-list">
        <div class="list-header">
            {{ $i18n.t("subscription.history_list_title") }}
            </div>
        <div class="list-content">
            <div class="list-item" v-for="subscription in subscriptions" :key="subscription.id">
                <div><strong>{{ subscription.PlanName }}</strong></div>
                <!-- <div>¥{{ subscription.price }}</div> -->
                <div>{{ subscription.StartTime }}</div>
                <div>{{ subscription.EndTime }}</div>
                <div>
                    <span class="status" :class="subscription.Status">
                        {{ getStatusText(subscription.Status) }}
                    </span>
                </div>
                <!-- <div>{{ subscription.remaining }}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
export default {
    name: 'SubscriptionList',
    props: {
        subscriptions: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        getStatusText(status) {
            const statusMap = {
                'active': i18n.t("subscription.history_list_item_status_active"),
                'expired': i18n.t("subscription.history_list_item_status_expire"),
                'pending': i18n.t("subscription.history_list_item_status_pending")
            };
            return statusMap[status] || status;
        }
    }
}
</script>

<style scoped>
.subscription-list {
    margin: 0 20px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    max-height: 58vh;
    display: flex;
    flex-direction: column;
}

.list-header {
    background: #2c3e50;
    color: white;
    padding: 10px 10px;
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0; /* 防止头部被压缩 */
}

.list-content {
    flex: 1;
    overflow-y: auto; /* 垂直滚动 */
    overflow-x: hidden; /* 隐藏水平滚动条 */
}

.list-item {
    font-size: 13px;
    padding: 10px 10px;
    border-bottom: 1px solid #eee;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 0.8fr;
    gap: 10px;
    align-items: center;
}

.list-item:hover {
    background: #f8f9fa;
}

.list-item:last-child {
    border-bottom: none; /* 移除最后一项的底部边框 */
}

.status {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.9em;
    font-weight: bold;
}

.status.active {
    background: #d4edda;
    color: #155724;
}

.status.expired {
    background: #E2E3E5;
    color: #6C757D;
}

.status.pending {
    background: #fff3cd;
    color: #856404;
}

/* 自定义滚动条样式 */
.list-content::-webkit-scrollbar {
    width: 6px;
}

.list-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.list-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.list-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

@media (max-width: 268px) {
    .list-item {
        grid-template-columns: 1fr;
        gap: 10px;
    }
    
    .subscription-list {
        max-height: 300px; /* 小屏幕上减少高度 */
    }
}
</style>